import { widgetInfo, ForecastType, cType, WidgetType, PaletteType } from "./store";
import { getOrgLocationForWidget, getConditionsForWidget, getForecastForWidget, getAqiForWidget } from "./api.svelte";
let widget;
widgetInfo.subscribe(w => {
    widget = w;
});
export async function parseBuilderMessage(message) {
    let widgetBuilderParams = JSON.parse(message);
    let widgetState = JSON.parse(JSON.stringify(widget));
    let orgLoc = await getNextWidgetOrgLoc(widgetBuilderParams);
    if (orgLoc != widgetState.orgLocId) {
        widgetState.orgLocId = orgLoc;
    }
    let lr = await getLightningRadius(widgetBuilderParams);
    widgetState.lightningRadius = lr;
    let strikeType = await getLightningStrikeType(widgetBuilderParams);
    widgetState.lightningStrikeType = strikeType;
    let type = await updateWidgetType(widgetBuilderParams);
    widgetState.type = type;
    let primaryCondition = await updatePrimaryCondition(widgetBuilderParams);
    widgetState.primaryCondition = primaryCondition;
    let secondaryConditions = await updateSecondaryConditions(widgetBuilderParams);
    widgetState.widgetConditions = secondaryConditions;
    let hourlyForecast = await updateHourlyForecast(widgetBuilderParams);
    let dailyForecast = await updateDailyForecast(widgetBuilderParams);
    let forecasts = [];
    if (hourlyForecast != undefined) {
        forecasts.push(hourlyForecast);
    }
    if (dailyForecast != undefined) {
        forecasts.push(dailyForecast);
    }
    widgetState.widgetForecasts = forecasts;
    let theme = await updateTheme(widgetBuilderParams);
    widgetState.theme = theme;
    let headerMessage = await updateHeaderMessage(widgetBuilderParams);
    widgetState.headerMessage = headerMessage;
    widgetInfo.update(widget => {
        return Object.assign({}, widgetState);
    });
}
async function getNextWidgetOrgLoc(widgetParams) {
    if (widgetParams.orgLocId && widget.orgLocId != widgetParams.orgLocId) {
        let newOrgLoc = widgetParams.orgLocId;
        getOrgLocationForWidget(widgetParams.orgLocId);
        getConditionsForWidget(widgetParams.orgLocId);
        getForecastForWidget(widgetParams.orgLocId, ForecastType.HOURLY);
        getForecastForWidget(widgetParams.orgLocId, ForecastType.DAILY);
        getAqiForWidget(widgetParams.orgLocId);
        return newOrgLoc;
    }
    return widget.orgLocId;
}
async function updateHeaderMessage(widgetBuilderParams) {
    if (widgetBuilderParams.headerMessage != undefined) {
        return widgetBuilderParams.headerMessage;
    }
    return undefined;
}
async function updateTheme(widgetBuilderParams) {
    if (widgetBuilderParams.theme != undefined && widgetBuilderParams.theme in PaletteType) {
        return widgetBuilderParams.theme;
    }
    return widget.theme;
}
async function updateDailyForecast(widgetBuilderParams) {
    if (widgetBuilderParams.dailyWidgetForecast != undefined && widgetBuilderParams.dailyWidgetForecast in cType) {
        const dailyForecast = {
            id: 'dayPreview',
            forecastType: ForecastType.DAILY,
            conditionType: widgetBuilderParams.dailyWidgetForecast
        };
        // getForecastForWidget(widget.orgLocId, ForecastType.DAILY);
        return dailyForecast;
    }
    return undefined;
}
async function updateHourlyForecast(widgetBuilderParams) {
    if (widgetBuilderParams.hourlyWidgetForecast != undefined && widgetBuilderParams.hourlyWidgetForecast in cType) {
        const hourForecast = {
            id: 'hourPreview',
            forecastType: ForecastType.HOURLY,
            conditionType: widgetBuilderParams.hourlyWidgetForecast
        };
        // getForecastForWidget(widget.orgLocId, ForecastType.HOURLY);
        return hourForecast;
    }
    return undefined;
}
async function updateSecondaryConditions(widgetBuilderParams) {
    if (widgetBuilderParams.widgetConditions) {
        return widgetBuilderParams.widgetConditions.map(c => ({ conditionType: c }));
    }
    return widget.widgetConditions;
}
async function updatePrimaryCondition(widgetBuilderParams) {
    if (widgetBuilderParams.primaryCondition != undefined && widgetBuilderParams.primaryCondition in cType) {
        return widgetBuilderParams.primaryCondition;
    }
    return widget.primaryCondition;
}
async function updateWidgetType(widgetBuilderParams) {
    if (widgetBuilderParams.type != undefined && widgetBuilderParams.type in WidgetType) {
        return widgetBuilderParams.type;
    }
    return widget.type;
}
// A widget has one lightning policy: CG (LR-C2G) or Blended (LR1). For CG the widget tracks the
// primary zone, which is the lowest-threshold LR-C2G trigger (matches widget-api).
function getLightningTrigger(policies) {
    var _a;
    const cgZones = policies
        .filter(p => p.policyTypeShortName === "LR-C2G")
        .sort((a, b) => a.threshold - b.threshold);
    return (_a = cgZones[0]) !== null && _a !== void 0 ? _a : policies.find(p => p.policyTypeShortName === "LR1");
}
async function getLightningRadius(widgetBuilderParams) {
    if (widgetBuilderParams.policies && widgetBuilderParams.policies.length > 0) {
        var trigger = getLightningTrigger(widgetBuilderParams.policies);
        if (trigger && trigger.threshold)
            return trigger.threshold;
    }
    return widget.lightningRadius;
}
async function getLightningStrikeType(widgetBuilderParams) {
    if (widgetBuilderParams.policies && widgetBuilderParams.policies.length > 0) {
        var trigger = getLightningTrigger(widgetBuilderParams.policies);
        if (trigger)
            return trigger.policyTypeShortName === "LR-C2G" ? "CG" : "Blended";
    }
    return widget.lightningStrikeType;
}
